// src/internal/api/ApiError.ts
var ApiError = class extends Error {
  constructor(status, body) {
    super(`API error ${status}`);
    this.status = status;
    this.body = body;
    this.name = "ApiError";
  }
  status;
  body;
};

export { ApiError };
//# sourceMappingURL=chunk-LEGW4QDU.js.map
//# sourceMappingURL=chunk-LEGW4QDU.js.map